import { render, staticRenderFns } from "./BookingChart3.vue?vue&type=template&id=54ad2de7&scoped=true"
import script from "./BookingChart3.vue?vue&type=script&lang=js"
export * from "./BookingChart3.vue?vue&type=script&lang=js"
import style0 from "./BookingChart3.vue?vue&type=style&index=0&id=54ad2de7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad2de7",
  null
  
)

export default component.exports